export default __webpack_public_path__ + "static/media/06.9a04580e.jpg";